<micro-select-combo #sel
              placeholder="Mps Scope"
              [mode]="mode"
              [(id)]="mpsScope"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
